import { AgenteEndereco } from './agente-endereco.interface';
import { Injectable } from '@angular/core';

const ORIGINATOR = 'id_session_endereco_agente';
const ENDERECO = 'id_sessigon_endereco_total';

@Injectable()
export class PesadosBrasilStorage {

  constructor() { }

  registerAgenteEndereco(agenteEndereco: AgenteEndereco) {
    this.setStorage(ORIGINATOR, agenteEndereco);
  }

  registerEnderecoTotal(endereco) {
    this.setStorage(ENDERECO, endereco);
  }

  clear(): void {
    sessionStorage.removeItem(ENDERECO);
    sessionStorage.removeItem(ORIGINATOR);
  }

  get agenteEndereco() {
    return this.getStorage(ORIGINATOR);
  }

  get enderecoTotal() {
    return this.getStorage(ENDERECO);
  }

  private setStorage(key: string, value: any) {
    sessionStorage.setItem(key, btoa(JSON.stringify(value)));
  }

  private getStorage(key: string): any {
    const value = sessionStorage.getItem(key);
    if (value) {
      return JSON.parse(atob(value));
    }
    return {};
  }
}
